// extracted by mini-css-extract-plugin
export var quantityInput = "_lx-0";